module.exports = __webpack_public_path__ + "img/44.9.TU.da459ddd.png";